module.exports ={
    title: ['跨境支付业务系统','Cross-Border Pmt Bus. Sys.'],
    account: ['登录账号','Login Account'],
    account_input: ['手机号/邮箱','Mobile No./Email Addr.'],
    password: ['密码','Password'],
    forgotPassword: ['忘记密码','Forgot Password'],
    login: ['登录','Login'],
    register1: ['没有账号?','Don\'t have an account?'],
    register2: ['马上注册',' Register now'],
    //找回密码
    forgot:{
        title: ['跨境业务系统','Cross-Border Bus. system'],
        forgotPwdTitle: ['找回密码','retrieve pwd'],
        mobilePlaceholder: ['请输入手机号/邮箱','please mobile No./email addr'],
        imageCodePlaceholder: ['图片验证码','image verif. code'],
        smsCodePlaceholder: ['验证码','verif. code'],
        newPwdPlaceholder: ['请设置新的登录密码','Please set a new login pwd'],
        confirmPwdPlaceholder: ['请再次确认登录密码','Please set a new login pwd again'],
        submitBtn: ['确定','submit'],
        rememberPwdText: ['想起密码？','remember pwd?'],
        loginLink: ['马上登录','log in immediately'],
        copyrightText: ['易生支付有限公司 版权所有','Easy Pay co.ltd. all rights reserved'],
        icpText: ['津ICP备11001957号','Tianjin ICP Record No. 11001957'],
        policeRecordText: ['津公网安备12010102000360号','Tianjin Public Network Security Record No. 12010102000360'],
        privacyPolicyText: ['隐私政策','privacy policy']
    },
    //重置密码
    reset:{
        czmm: ['重置密码','reset pwd'],
        szxmm: ['设置新密码','set new pwd'],
        cfxmm: ['请重复新密码','re-enter the new pwd'],
        qcfxmm: ['确认重置密码','confirm pwd reset'],
        xqmm: ['想起密码？','remember pwd?'],
        msdl: ['马上登录','log in immediately'],
        qqrmm: ['请确认密码','confirm pwd'],
        byz: ['两次输入的密码不一致','The two entered pwd are inconsistent'],
        success: ['新密码设置成功～','The new password has been successfully set'],
    },
    //注册
    register:{
        xyh: ['新用户注册','new user register'],
        name: ['手机号/邮箱','Mobile No./Email Addr.'],
        yzm: ['图片验证码','image verif. code'],
        yzm2: ['验证码','verif. code'],
        dlmm: ['请设置登录密码','please set login pwd'],
        ts1: ['必须是8-20位英文大写、小写字母、数字或符号，至少包含三种','It must be 8-20 chars (uppercase, lowercase, numbers, or symbols), with at least three types.'],
        qrmm: ['请确认密码','confirm pwd'],
        byz: ['两次输入的密码不一致','The two entered pwd are inconsistent'],
        wty: ['我已阅读并同意','I have read and agree to'],
        xy: ['《跨境支付业务系统用户协议》',',《Cross-Border Payment Sys. User Agreement》'],
        zhuce: ['立即注册','register immediately'],
        yzh: ['已拥有账号？','have an account?'],
        msdl: ['马上登录','log in immediately'],
        shuruymz: ['请输入图片验证码','please enter image verif. code'],
        tupiancw: ['图片验证码错误','image verif. code error'],
        gouxuanxy: ['请勾选同意该服务协议','please check to agree to the service agreement'],
        jianchacw: ['请检查 手机号/邮箱 是否填写正确','please check if the mobile no./email address is filled correctly'],
        qtianxeitel: ['请填写 手机号/邮箱','please fill in the mobile no./email'],
        yzc: ['邮箱已经注册了','The email is already registered'],
        ytg: ['邮箱验证通过','email verification passed'],
        qjc: ['请检查邮箱是否填写正确','please check if the email addr. is filled correctly'],
        yzctel: ['手机号已经注册了','mobile no. is already registered'],
        tgtel: ['手机号验证通过','mobile no. verification passed'],
        jianchatel: ['请检查手机号是否填写正确','please check if the mobile no. is filled correctly'],
        zccg: ['注册成功','registration successful'],
    }
}
